import { STATUS_ENUM } from 'constants/report';

import * as React from 'react';

import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface QaStatusChipProps {
  reportStatus: string;
  passedQa: boolean | null;
  mapOnly?: boolean | null;
}

export const QaStatusChip: React.FC<QaStatusChipProps> = ({
  reportStatus,
  passedQa,
  mapOnly,
}) => {
  const { t } = useTranslation();

  if (passedQa === true) {
    return (
      <Chip
        size="small"
        color="success"
        label={
          mapOnly ? t('reportsQa.qa.approvedMapOnly') : t('reportsQa.qa.approved')
        }
      />
    );
  }
  if (passedQa === false) {
    return <Chip size="small" color="error" label={t('reportsQa.qa.rejected')} />;
  }
  if (reportStatus === STATUS_ENUM.SUCCESS) {
    return (
      <Chip
        size="small"
        color="warning"
        variant="outlined"
        label={t('reportsQa.qa.awaiting')}
      />
    );
  }
  return <span>—</span>;
};

export const formatReportStatus = (status: string): string =>
  (status ?? '')
    .toLowerCase()
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

export const ReportStatusChip: React.FC<{ status: string }> = ({ status }) => {
  const color =
    status === STATUS_ENUM.SUCCESS
      ? 'success'
      : status === STATUS_ENUM.FAILED
        ? 'error'
        : 'info';
  return (
    <Chip
      size="small"
      variant="outlined"
      color={color}
      label={formatReportStatus(status)}
    />
  );
};
